
import { Component, Prop, PropSync, Ref, Vue } from 'nuxt-property-decorator'
import { NeoField } from '@kodadot1/brick'

const components = {
  Auth: () => import('@/components/shared/Auth.vue'),
  MetadataUpload: () => import('@/components/shared/DropUpload.vue'),
  BasicInput: () => import('@/components/shared/form/BasicInput.vue'),
  NeoField,
}

@Component({ components })
export default class BaseCollectionForm extends Vue {
  @Prop({ type: String, default: 'mint.collection.create' }) label!: string
  @Prop(Boolean) protectiveMargin!: boolean
  @PropSync('name', { type: String }) vName!: string
  @PropSync('description', { type: String }) vDescription!: string
  @PropSync('file', { type: Blob }) vFile!: Blob | null

  @Ref('collectionName') readonly collectionName
  @Ref('collectionImage') readonly collectionImage
  public checkValidity() {
    return (
      this.collectionImage.checkValidity() &&
      this.collectionName.checkValidity()
    )
  }
}
